<script lang="ts">
  import { slide, fade } from "svelte/transition";
  import { sineOut } from "svelte/easing";
  export let title: string;
  export let visible = false;
  let iconDirection = "right";
  iconDirection = visible ? "down" : "right";

  const toggleVisible = () => {
    visible = !visible;
    iconDirection = visible ? "down" : "right";
  };
</script>

<div class="accordion">
  <div class="header" on:click={() => toggleVisible()}>
    <span class="icon"><i class="fas fa-chevron-{iconDirection}" /></span>
    <h2>{title}</h2>
  </div>

  {#if visible}
    <div class="content" transition:slide={{ delay: 250, duration: 500 }}>
      <slot />
    </div>
  {/if}
</div>

<style>
  .icon {
    font-size: large;
    color: rgb(109, 55, 33);
    margin: 10px;
  }
  h2 {
    margin-bottom: 0px;
    color: rgb(109, 55, 33);
  }
  .header {
    display: flex;
    align-items: baseline;

    border-bottom: 3px wheat solid;
    margin-bottom: 10px;
  }
  .accordion {
    margin: 1em;
  }
</style>
